const homepageHero = () => {
    const hero = document.querySelector('.homepage-hero');
    const header = document.querySelector('header .main-header');
    if (!hero || !header) return;

    function setHeroPadding() {
        // read computed padding-top (fallback to 0 if not set)
        const style = window.getComputedStyle(hero);
        const defaultPaddingTop = parseFloat(style.paddingTop) || 0;
        const headerHeight = header.scrollHeight;
        hero.style.paddingTop = (defaultPaddingTop + headerHeight) + 'px';
    }

    // fire on initial load
    window.addEventListener('load', setHeroPadding);

    // fire on every window resize
    window.addEventListener('resize', setHeroPadding);
};

export default homepageHero;
